import axios from 'axios';
import { UseTraceContext } from '@b2bsoft/tracecontext';

import {
    UseLoaderInterceptor,
    UseQaInterceptor,
    UseErrorInterceptor,
} from './interceptors';
import StoreModel from 'webPosApp/models/Index';

const baseHttp = axios.create();
const apiHttp = axios.create({});
const logHttp = axios.create({});

export interface ApiOptions {
    accessCode?: string | null;
    isQA?: boolean;
    brand?: string | null;
    deviceId?: string | null;
    locationId?: number | null;
    token?: string | null;
    carrierB2BId?: string | null;
    registerId?: string | null;
}

export function setupAPI(store: StoreModel, options: ApiOptions) {
    if (options.isQA) {
        UseQaInterceptor(apiHttp);
    }

    UseErrorInterceptor(apiHttp);
    UseLoaderInterceptor(apiHttp);

    UseTraceContext(apiHttp, store.traceContext);
    UseTraceContext(logHttp, store.traceContext);

    updateAPI(options);
    return apiHttp;
}

export function updateAPI(options: ApiOptions) {
    if (options.brand) {
        apiHttp.defaults.headers.common['Brand'] = options.brand;
        logHttp.defaults.headers.common['Brand'] = options.brand;
    }

    if (options.deviceId) {
        apiHttp.defaults.headers.common['DeviceId'] = options.deviceId;
        logHttp.defaults.headers.common['DeviceId'] = options.deviceId;
    }

    if (options.locationId) {
        apiHttp.defaults.headers.common['LocationId'] = options.locationId;
        logHttp.defaults.headers.common['LocationId'] = options.locationId;
    }

    if (options.accessCode) {
        apiHttp.defaults.headers.common['OlrIdentity'] = options.accessCode;
        logHttp.defaults.headers.common['OlrIdentity'] = options.accessCode;
    }

    if (options.carrierB2BId) {
        apiHttp.defaults.headers.common['CarrierB2BId'] = options.carrierB2BId;
        logHttp.defaults.headers.common['CarrierB2BId'] = options.carrierB2BId;
    }

    if (options.registerId) {
        apiHttp.defaults.headers.common['RegisterId'] = options.registerId;
        logHttp.defaults.headers.common['RegisterId'] = options.registerId;
    }

    if (options.token) {
        apiHttp.defaults.headers.common[
            'Authorization'
        ] = `Bearer ${options.token}`;
        logHttp.defaults.headers.common[
            'Authorization'
        ] = `Bearer ${options.token}`;
    }

    return apiHttp;
}

export interface ResponseWrapper<T> {
    data: T | null;
    errors: ResponseError[] | undefined;
}
export interface ResponseError {
    code: string | null | undefined;
    message: string | null | undefined;
    data: any | null | undefined;
}

export { apiHttp as http, baseHttp, logHttp };
